import DomainCommon from './common'

const StatusService = {
    listStatus: () => new Promise((resolve, reject) =>
        DomainCommon.fetchGet({
            url: `${DomainCommon.getUecareApiUrl()}/status`,
            resolve, reject
        })),
}

export default StatusService



// WEBPACK FOOTER //
// ./src/service/status.js